import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Brands } from "../models/brands";
import { ConfigService } from "./config.service";
import { Router } from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class BrandService {
    private readonly storageKey = 'dcodeAppSelectedBrand';
    brands: string[] = [Brands.Scania, Brands.ScaniaCn, Brands.International];

    private _selectedBrand: string;

    constructor(private router: Router, private configService: ConfigService) {
        const storedBrand = localStorage.getItem(this.storageKey);
        this._selectedBrand = storedBrand && this.brands.includes(storedBrand)
            ? storedBrand
            : environment.defaultBrand;
        this.configService.setBrand(this._selectedBrand);
    }

    get selectedBrand(): string {
        return this._selectedBrand;
    }

    set selectedBrand(brand: string) {
        this._selectedBrand = brand;
        localStorage.setItem(this.storageKey, brand);
        this.configService.setBrand(brand);

        // Redirect to the base URI to reinitialize the app with the new brand configuration
        // window.location.href = document.baseURI;
        this.refreshCurrentRoute();
    }

    refreshCurrentRoute(): void {
        const currentUrl = this.router.url;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigateByUrl(currentUrl);
        });
    }

    setToDefaultBrand() {
        localStorage.removeItem(this.storageKey);
        this._selectedBrand = environment.defaultBrand;
        this.configService.setBrand(this._selectedBrand);
    }

    setAvailableBrandsFromAuthBrand(authBrand: string) {
        switch (authBrand.toLowerCase()) {
            // Users with a Scania global account are allowed to access all brands, so we show all options
            case Brands.Scania.toLowerCase():
                this.brands = [Brands.Scania, Brands.ScaniaCn, Brands.International];
                break;
            case Brands.ScaniaCn.toLowerCase():
                this.brands = [Brands.ScaniaCn];
                break;
            case Brands.International.toLowerCase():
                this.brands = [Brands.International];
                break;
            default:
                this.brands = [environment.defaultBrand];
                break;
        }
    }

    setSelectedBrandWithoutRedirect(brand: string) {
        if (this.brands.includes(brand)) {
            this._selectedBrand = brand;
            localStorage.setItem(this.storageKey, brand);
            this.configService.setBrand(brand);
        } else {
            console.warn(`Brand ${brand} is not available. Available brands:`, this.brands);
        }
    }
}